import React from 'react';
import {connect} from "react-redux";
import { SortableContainer, SortableElement,  } from 'react-sortable-hoc';

import {updateContractsList} from "./contractsActions";
import ContractsListItem from "./ContractsListItem";
import {arrayMove} from "../../misc";
import CheckBox from "../PageLayout/CheckBox";

const SortableItem = SortableElement(({ contract, contractIndex }) => {
  return <ContractsListItem contract={contract} contractIndex={contractIndex} />
});

const SortableList = SortableContainer(({ contractsList, allSelectClick }) => {
  // const sections = sortByOrder(discountSections);
  return (
    <ul className="contracts-list fix-ul">
      <div className="fs-toggle-popup__table-row bordered flex--center">
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--drag"/>
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--check">
          <CheckBox checked={contractsList.length && contractsList.every(cont => cont.selected)}
                    innerStyle="none"
                    type={"medium"}
                    disabled={false}
                    onChecked={allSelectClick}
                    text=""/>
        </div>
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name"/>
      </div>
      {contractsList.map((contract, contractIndex) => {
        return (
          <SortableItem key={contract.id}
                        contract={contract}
                        index={contractIndex}
                        contractIndex={contractIndex}/>
        )
      })}
    </ul>
  );
});

const ContractsList = (props) => {

  const {contractsList, updateContractsList} = props;

  const onSortEnd = ({oldIndex, newIndex}) => {
    if (oldIndex === newIndex) {
      return
    }
    let newContractsList = arrayMove(contractsList, oldIndex, newIndex)
      .map((contract, contractIndex) => {
        contract.order = contractIndex;
        return contract
      });
    updateContractsList(newContractsList);
  };

  const allSelectClick = () => {
    if (contractsList.every(cont => cont.selected)) {
      updateContractsList(contractsList.map((contract) => {
        contract.selected = false;
        return contract
      }));
    } else {
      updateContractsList(contractsList.map((contract) => {
        contract.selected = true;
        return contract
      }));
    }
  }

  const onSortStart = () => {
    // document.body.style.cursor = "grabbing";
    // setWizardDraggingGroupIndex(event.index);
  }

  const shouldCancelStart = () => {
    // return !(event.target.classList.contains("wizard-item__dots") || event.target.closest(".wizard-item__dots"))
  }

  if (!contractsList.length) {
    return (
      <div style={{height: "90%"}} className="color-gray flex flex--center">No contracts uploaded</div>
    )
  }

  return (
    <SortableList contractsList={contractsList}
                  allSelectClick={allSelectClick}
                  helperClass='sortableHelper'
                  axis={"y"}
                  useDragHandle={true}
      // pressDelay={100}
                  shouldCancelStart={shouldCancelStart}
                  onSortStart={onSortStart}
                  onSortEnd={onSortEnd} />
  )
};

const mapStateToProps = (store) => {
  const {contractsList} = store.contractsState;
  return {
    contractsList,
  }
};

const mapDispatchToProps = {
  updateContractsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsList)
